import ProjectView from "../project-view"
import ProjectViews from "../project-views"
import {ViewType} from "../../../gd/const/views/view-type"
import ApiProject from "../../../gd/api/project"
import ApiRequestForm from "../../../gd/api/request-form"
import ProjectView_Form from "../views/form/form-view"
import {projectViews_createProjectViewFromConfig} from "./create"

// const debug = "projectView_delete"
const debug = false

export default async function projectView_delete(projectViews: ProjectViews, view:ProjectView): Promise<void> {

    debug && console.log(debug, 'process', view)

    // if workspace last view is removed then switch to Everything view first
    if (
        projectViews.project.isWorkspace
        && projectViews.currentView.id === view.id
        && projectViews.models.length === 1
    ) {
        const everythingView = projectViews_createProjectViewFromConfig(projectViews, {
            systemType: ViewType.PROJECT_EVERYTHING
        })
        projectViews.setCurrentView(everythingView)
    }

    // Why we delete differentely ??? need review

    switch (view.systemType) {
        case ViewType.PROJECT_TODOS:
        case ViewType.PROJECT_PAGE:
        case ViewType.PROJECT_WHITEBOARD:
            await ApiProject.deleteView(projectViews.project.id, view.id).promise()
            break

        case ViewType.PROJECT_REQUEST_FORMS:
            gd.modals.confirm.deleteByName('Form', view.name, async ()=>{
                const formView = view as ProjectView_Form

                _.remove(projectViews.project.properties.forms, form=>form.id === formView.formId)

                await formView.saveAppSettings(undefined, false)
                projectViews.remove(formView.id)
                await projectViews.save()

                await ApiRequestForm.updateForm(formView.formId, {isDeleted: true})

                gd.modal.hide()
            })
            break

        default:
            await view.saveAppSettings(undefined, false) // Why not to create method remove appSettings ????
            projectViews.remove(view.id)
            await projectViews.save()
    }
}
